export default {
  shortList: [
    { name: "Manager", code: "manager" },
    { name: "Doctor", code: "doctor" },
    { name: "Medic rezident", code: "trainee" },
    { name: "Asistentă", code: "nurse" },
    { name: "Personal administrativ", code: "admin" }
  ]
};
